import QuickResult from "../../components/quickResult/QuickResult.jsx";

const EvQuickResult = () => <QuickResult />;

export default EvQuickResult;
